import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const pages = (cur, last) => {
  const s = new Set([1, last, cur - 1, cur, cur + 1].filter((p) => p >= 1 && p <= last));
  const arr = [...s].sort((a, b) => a - b);
  return arr.flatMap((p, i) => (i && p - arr[i - 1] > 1 ? ['…', p] : [p]));
};

export function Pager({ page, size, total, onPage, onSize }) {
  const last = Math.max(1, Math.ceil(total / size));
  const btn = 'h-9 min-w-9 px-2 rounded-xl text-sm font-semibold transition-colors disabled:opacity-40';
  return (
    <div className="flex flex-wrap items-center justify-between gap-3" data-testid="fuel-pager">
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <span>{total ? `${(page - 1) * size + 1}–${Math.min(page * size, total)} / ${total}` : '0 kayıt'}</span>
        <Select value={String(size)} onValueChange={(v) => onSize(Number(v))}>
          <SelectTrigger className="h-8 w-20 rounded-lg" data-testid="fuel-page-size"><SelectValue /></SelectTrigger>
          <SelectContent>{[12, 24, 48].map((n) => <SelectItem key={n} value={String(n)}>{n}</SelectItem>)}</SelectContent>
        </Select>
        <span>/ sayfa</span>
      </div>
      <div className="flex items-center gap-1">
        <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)} className={`${btn} hover:bg-slate-100 dark:hover:bg-slate-800`} data-testid="fuel-page-prev"><ChevronLeft className="h-4 w-4" /></button>
        {pages(page, last).map((p, i) => (p === '…' ? <span key={`e${i}`} className="px-1 text-slate-400">…</span> : (
          <button key={p} type="button" onClick={() => onPage(p)} className={`${btn} ${p === page ? 'bg-orange-500 text-white' : 'hover:bg-slate-100 dark:hover:bg-slate-800'}`} data-testid={`fuel-page-${p}`}>{p}</button>
        )))}
        <button type="button" disabled={page >= last} onClick={() => onPage(page + 1)} className={`${btn} hover:bg-slate-100 dark:hover:bg-slate-800`} data-testid="fuel-page-next"><ChevronRight className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
